export const discordKeys = {
    guildInfo: (subdomain) => ['discord', 'guildInfo', subdomain],
    failedRoles: (subdomain) => ['discord', 'failedRoles', subdomain],
};
